import { FelaCSS, spacing } from '@bridebook/ui';
import { IMAGES_BASE_URL } from '@bridebook/toolbox/src/buildImageUrl';

interface IStyles {
  wrapper: FelaCSS;
  logo: FelaCSS;
  logoCountrySelector: FelaCSS;
  auth: FelaCSS;
  image(imgPostfix: string, isVariant?: boolean): FelaCSS;
  imageContainer: FelaCSS;
  qrWrapper: FelaCSS;
  signupContent: FelaCSS;
}

const styles: IStyles = {
  wrapper: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridTemplateRows: '1fr',
    gridTemplateAreas: `
          "auth"
          `,
    onlyWidthTabletSm: {
      gridTemplateRows: 'auto 1fr',
      gridTemplateAreas: `
            "logo"
            "auth"
            `,
    },
    minWidthTabletLg: {
      gridTemplateRows: 'auto',
      gridTemplateColumns: 'minmax(350px, 1fr) 1fr',
      gridTemplateAreas: `
              "logo ."
              "auth image"
              "auth image"
            `,
    },
  },
  logo: {
    display: 'none',
    minWidthTablet: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      gridArea: 'logo',
      height: 'max-content',
      marginLeft: 12,
      marginTop: 6,
      paddingRight: 12,
      flexWrap: 'nowrap',
    },
  },
  logoCountrySelector: {
    display: 'none',
    minWidthTabletLg: {
      display: 'block',
    },
  },
  auth: {
    gridArea: 'auth',
    width: 'min(100%, 400px)',
    justifySelf: 'center',
    paddingTop: 6,
    paddingHorizontal: 6,

    minWidthTabletLg: {
      padding: 0,
    },
  },
  image: (imgPostfix, isVariant) => {
    const imageName = isVariant
      ? `background-desktop-qr-en-v3.png`
      : `background-desktop-qr-${imgPostfix}.jpg`;

    return {
      display: 'none',

      minWidthTabletLg: {
        gridArea: 'image',
        backgroundImage: `url(${IMAGES_BASE_URL}/assets/signup-imgs/${imageName})`,
        backgroundSize: 'cover',
        backgroundPosition: isVariant ? 'center center' : 'center 80%',
        height: '100vh',
        backgroundRepeat: 'no-repeat',
        gridRowStart: 1,
        display: 'block',
        marginRight: isVariant ? 0 : spacing[12],
      },

      minWidthDesktopLg: {
        maxWidth: isVariant ? '100%' : '75%',
        marginRight: 0,
      },
    };
  },

  imageContainer: {
    display: 'none',

    minWidthTabletLg: {
      display: 'block',
      position: 'relative',
      gridArea: 'image',
      gridRowStart: 1,
    },
  },

  qrWrapper: {
    position: 'absolute',
    bottom: 0,
    right: spacing[8],
    width: 'fit-content',
  },

  signupContent: {
    supportsSafeAreaInset: {
      paddingTop: `env(safe-area-inset-top)`,
      marginBottom: spacing[4],
    },
    display: 'grid',
    gap: spacing[5],
    gridTemplateColumns: 'subgrid',
  },
};

export default styles;
